// extracted by mini-css-extract-plugin
export default {"root":"_29ZLCKTr","steady":"_3naFKn-p","absolute":"Rx0HzQys","icon":"HyECpAfS","badge":"_3hv6zNCL"};